<template>
  <SettingSection
    title="Реестры"
    icon-variant="registries"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "RegistriesSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
      `,
      links: [
        {
          label: "Каталог",
          route: { name: "CatalogItems" },
        },
        {
          label: "Продукты",
          route: { name: "ProductsRegistry" },
        },
        {
          label: "Единицы измерения груза",
          route: { name: "CargoUnits" },
        },
        {
          label: "Теги блога",
          route: { name: "CommunicationTags" },
        },
        {
          label: "Характеристики груза",
          route: { name: "CargoProperties" },
        },
        {
          label: "Позиции груза",
          route: { name: "CargoItems" },
        },
      ],
    };
  },
};
</script>
